import React from 'react';
import ScrollReveal from '../components/ScrollReveal';
import './LegalPage.css';
import SEO, { seoConfig } from '../components/SEO';

export default function LegalNotice({ t }) {
  return (
    <div className="legal-page">
      <SEO
        title="Mentions légales | Daniela Parito Architecture"
        description="Mentions légales du cabinet Daniela Parito Architecture, architecte à Montpellier."
        keywords="mentions légales, daniela parito architecture, architecte montpellier"
        noindex
      />

      <div className="page-container">
        <ScrollReveal>
          <h1 className="page-title">Mentions Légales</h1>
        </ScrollReveal>

        <div className="legal-content">
          <ScrollReveal delay={0.1}>
            <section className="legal-section">
              <h2 className="legal-section-title">Éditeur du site</h2>
              <p>
                <strong>DP Architecture</strong><br />
                SARL au capital de 1000,00 € (fixe) €<br />
                Siège social : 663, rue du Pré aux Clercs - Le Fontenelle C3<br />
                34090 MONTPELLIER FRANCE<br />
                RCS Montpellier : [NUMÉRO RCS]<br />
                SIRET : 80523324400013<br />
                TVA intracommunautaire : FR07805233244
              </p>
              <p>
                <strong>Directeur de la publication :</strong> Daniela PARITO<br />
                <strong>Email :</strong> daniela.parito@gmail.com<br />
                <strong>Téléphone :</strong> 06 14 90 25 13
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <section className="legal-section">
              <h2 className="legal-section-title">Hébergement</h2>
              <p>
                Le site est hébergé par :<br />
                <strong>OVH</strong><br />
                2, rue Kellermann<br />
                59100, Roubaix<br />
                Téléphone : 1007
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.3}>
            <section className="legal-section">
              <h2 className="legal-section-title">Propriété intellectuelle</h2>
              <p>
                L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
              </p>
              <p>
                La reproduction de tout ou partie de ce site sur un support électronique quel qu'il soit est formellement interdite sauf autorisation expresse du directeur de la publication.
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.4}>
            <section className="legal-section">
              <h2 className="legal-section-title">Données personnelles</h2>
              <p>
                Conformément à la loi « Informatique et Libertés » du 6 janvier 1978 modifiée et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
              </p>
              <p>
                Pour exercer ces droits, vous pouvez nous contacter par email à : daniela.parito@gmail.com
              </p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.5}>
            <section className="legal-section">
              <h2 className="legal-section-title">Crédits</h2>
              <p>
                <strong>Conception et réalisation :</strong> SDR Web<br />
                <strong>Photographies :</strong> DP Architecture et partenaires<br />
                <strong>Ordre des Architectes :</strong> Région Occitanie n° 046166 et S16988
              </p>
            </section>
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
}